/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One roster a creator belongs to, described by its owning Drop.
 * @export
 * @interface OfficialForEntry
 */
export interface OfficialForEntry {
    /**
     * 
     * @type {string}
     * @memberof OfficialForEntry
     */
    dropId: string;
    /**
     * 
     * @type {string}
     * @memberof OfficialForEntry
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof OfficialForEntry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OfficialForEntry
     */
    logoUrl?: string;
    /**
     * Enabled members on that roster.
     * @type {number}
     * @memberof OfficialForEntry
     */
    memberCount: number;
}

/**
 * Check if a given object implements the OfficialForEntry interface.
 */
export function instanceOfOfficialForEntry(value: object): value is OfficialForEntry {
    if (!('dropId' in value) || value['dropId'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('memberCount' in value) || value['memberCount'] === undefined) return false;
    return true;
}

export function OfficialForEntryFromJSON(json: any): OfficialForEntry {
    return OfficialForEntryFromJSONTyped(json, false);
}

export function OfficialForEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfficialForEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'dropId': json['dropId'],
        'slug': json['slug'],
        'name': json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'memberCount': json['memberCount'],
    };
}

export function OfficialForEntryToJSON(json: any): OfficialForEntry {
    return OfficialForEntryToJSONTyped(json, false);
}

export function OfficialForEntryToJSONTyped(value?: OfficialForEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dropId': value['dropId'],
        'slug': value['slug'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'memberCount': value['memberCount'],
    };
}

